import { NotFound } from '@client/components/NotFound';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/not-found')({
    component: NotFound,
});
